module.exports = __webpack_public_path__ + "static/media/logo192PD.3d0aa44a.png";